import { FileSize } from '@/enum/FileSize'
import { VALIDATION_MESSAGES } from '@/constants/validationMessages'
import { validateFileExtension } from './validateFile'

export const validateImage = (file: File, formats: string[]) => {
  const errors = []
  if (file.size > FileSize.companyImage) {
    errors.push(VALIDATION_MESSAGES.file.sizeValidationErr)
  }
  if (formats && !validateFileExtension(file, formats)) {
    errors.push(VALIDATION_MESSAGES.file.formatValidationErr)
  }

  return errors
}

export const validateImageResolution = async (file: File, maxWidth: number, maxHeight: number): Promise<null | string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (evt: ProgressEvent<FileReader>) => {
      const img = new Image()
      img.onload = () => {
        if (img.width !== maxWidth || img.height !== maxHeight) {
          resolve(VALIDATION_MESSAGES.file.resolutionValidationErr)
          console.error(`Разрешение изображения (${img.width} / ${img.height}) отличается от требуемого (${maxWidth} x ${maxHeight}).`)
        }
        resolve(null)
      }
      img.src = (evt.target?.result as string) || ''
    }

    reader.onerror = () => reject(new Error('Не удалось прочитать файл'))
  })
}
